(() => {
  if (window.__l51PromoCountdownInit) return;
  window.__l51PromoCountdownInit = true;

  window.L51PromoCountdownIntervals = window.L51PromoCountdownIntervals || {};

  function parseDate(value){
    if (!value) return null;
    const clean = String(value).trim();
    const normalized = clean.includes('T') ? clean : clean.replace(' ', 'T');
    const parsed = new Date(normalized);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function pad(num){
    return String(num).padStart(2, '0');
  }

  function initCountdown(section){
    if (!section || section.dataset.l51PcInit === 'true') return;

    section.dataset.l51PcInit = 'true';

    const id = section.dataset.l51PcId || section.id;
    const startDate = parseDate(section.dataset.start);
    const endDate = parseDate(section.dataset.end);

    const daysEl = section.querySelector('[data-days]');
    const hoursEl = section.querySelector('[data-hours]');
    const minutesEl = section.querySelector('[data-minutes]');
    const secondsEl = section.querySelector('[data-seconds]');

    function updateCountdown(){
      if (section.dataset.hasTimer === 'false') {

        section.classList.add('is-visible');
      
        return;
      
      }
      if (!document.body.contains(section)) {
        clearInterval(window.L51PromoCountdownIntervals[id]);
        delete window.L51PromoCountdownIntervals[id];
        return;
      }

      const now = new Date();

      if (startDate && now < startDate) {
        section.classList.remove('is-visible');
        return;
      }

      if (!endDate || now >= endDate) {
        section.classList.remove('is-visible');
        return;
      }

      const diff = endDate.getTime() - now.getTime();

      if (diff <= 0) {
        section.classList.remove('is-visible');
        return;
      }

      section.classList.add('is-visible');

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateCountdown();

    if (window.L51PromoCountdownIntervals[id]) {
      clearInterval(window.L51PromoCountdownIntervals[id]);
    }

    window.L51PromoCountdownIntervals[id] = setInterval(updateCountdown, 1000);
  }

  function initAll(root = document){
    root.querySelectorAll('[data-l51-promo-countdown]').forEach(initCountdown);
  }

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('theme:cart:updated', () => {
    initAll();
  });

  document.addEventListener('cart:updated', () => {
    initAll();
  });

  const observer = new MutationObserver(() => {
    initAll();
  });

  observer.observe(document.documentElement, {
    childList:true,
    subtree:true
  });
})();